import '../../../../../scss/user-modal.scss';

import { createApp } from 'vue'
//import Vue from 'vue';

import Router from 'vue-router';
import UserModal from './UserModal';
import { userModalRoute, userModalRouter } from './router';
import { getPiniaInstance } from '../../../store/page-store';
import { getValueFromCurrentUrl } from '../../../../qaamgo/helper/query-fragment-params';
import { testIsNotNull, testIsTrimmedStringNotEmpty } from '../../../../lib/test-and-assert/test-base';
import { testIsValidUserModalRoute } from './test';
import { useUserRegisterPaymentModalStore } from '../../../store/modules/user-register-payment-modal-store';

//Vue.use(Router);

const userModalEl = document.createElement('div');
userModalEl.setAttribute('id', 'UserModal');

document.body.appendChild(userModalEl);

createApp(UserModal).use(getPiniaInstance()).use(userModalRouter).mount('#UserModal')


// TODO maybe switch to a different, more unique fragment key? remember to also change LoginView accordingly
const modalOpenFragment = getValueFromCurrentUrl('mp');

if (
    testIsNotNull(modalOpenFragment) &&
    testIsTrimmedStringNotEmpty(modalOpenFragment) &&
    testIsValidUserModalRoute(modalOpenFragment.trim())
) {
    const store = useUserRegisterPaymentModalStore();

    if (modalOpenFragment === userModalRoute.LOGIN || modalOpenFragment === userModalRoute.REGISTER) {
        store.setSkipPayment(true);
    }

    // only open user modal on page load after the /me request is finished
    store.openOnPage(modalOpenFragment.trim());
}
